var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableViewSwitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 4,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 28V25H14V28H28ZM28 23V19H14V23H28ZM28 17V14H14V17H28ZM14 30C13.45 30 12.979 29.8043 12.587 29.413C12.1957 29.021 12 28.55 12 28V14C12 13.45 12.1957 12.979 12.587 12.587C12.979 12.1957 13.45 12 14 12H28C28.55 12 29.021 12.1957 29.413 12.587C29.8043 12.979 30 13.45 30 14V28C30 28.55 29.8043 29.021 29.413 29.413C29.021 29.8043 28.55 30 28 30H14Z",
    fill: "#9097A5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 41.5,
    height: 41.5,
    rx: 3.75,
    stroke: "#9097A5",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableViewSwitch);
export default __webpack_public_path__ + "static/media/table-view-switch.7f825fd46adfcb3da78c54152aefea94.svg";
export { ForwardRef as ReactComponent };